/* esm.sh - applesauce-core@5.2.0/helpers/profile */
export * from "/*applesauce-core@5.2.0/esnext/helpers/profile.mjs";
